import apiClient from "@shared/services/apiClient";
import { getOrganizationSlugFromHostname } from "@shared/utils/orgLoginRouting";
import {
  BrowserTelemetryPayload,
  ReachabilityTelemetryStatus,
  getBrowserTelemetry,
} from "@shared/services/telemetry";

export type LoginFunnelStage =
  | "workspace_lookup_view"
  | "workspace_lookup_submit"
  | "workspace_lookup_resolved"
  | "workspace_lookup_not_found"
  | "workspace_lookup_redirect"
  | "login_page_view"
  | "login_submit_password"
  | "login_submit_passkey"
  | "login_requires_mfa"
  | "login_success"
  | "login_failed"
  | "forgot_workspace_view"
  | "forgot_workspace_submit"
  | "browser_gate_warning"
  | "browser_gate_warning_continue"
  | "browser_gate_blocked"
  | "browser_gate_override"
  | "reachability_probe_failed"
  | "reachability_probe_recovered"
  | "reachability_warning_acknowledged";

interface LoginFunnelEventInput {
  stage: LoginFunnelStage;
  resolved?: boolean;
  outcome?: "success" | "failure";
  auth_method?: "password" | "passkey" | "sso";
  policy_version?: string;
  duration_ms?: number;
  reachability_status?: ReachabilityTelemetryStatus;
  reachability_error?: string;
  warning_acknowledged?: boolean;
  browser_family?: BrowserTelemetryPayload["browser_family"];
  browser_major?: BrowserTelemetryPayload["browser_major"];
  policy_state?: "supported" | "warning" | "blocked";
  override_expires_at?: string;
  override_ttl_minutes?: number;
}

export async function trackLoginFunnelEvent(
  input: LoginFunnelEventInput,
): Promise<void> {
  try {
    const browserTelemetry = getBrowserTelemetry();
    await apiClient.post("/auth/login-funnel-event", {
      ...browserTelemetry,
      ...input,
      org_slug: getOrganizationSlugFromHostname(window.location.hostname),
    });
  } catch {
    // Best-effort only. Must not block login UX.
  }
}
